import { graphql } from "react-relay";

// gql
import "@components/team-join-create/TeamJoinCreate.gql";

/////////
// GQL //
/////////

export const fragments = {
  org: graphql`
    fragment TeamJoinCreateDialog_org on Org {
      ...TeamJoinCreate_org
      id
      primaryOrgCalendar
    }
  `,
};

export const query = graphql`
  query TeamJoinCreateDialogQuery(
    $orgRelayId: ID!
    $myCalendarIds: [String!]!
    $excludeMyTeams: Boolean
  ) {
    viewer {
      ...TeamJoinCreate_viewer
        @arguments(
          orgRelayId: $orgRelayId
          myCalendarIds: $myCalendarIds
          excludeMyTeams: $excludeMyTeams
        )
    }
  }
`;
